import { type RankingAllData } from '@prisma/client'
import { Link } from '@remix-run/react'

type RankProps = {
	number?: number | string
	label?: string
}
function Rank(props: RankProps) {
	const { number, label } = props

	if (!number) {
		return <div />
	}

	let displayNumber = typeof number === 'string' ? number : number.toLocaleString('en-US')
	return (
		<div className="flex flex-col items-center text-yellow-500">
			<div className="text-[2.25rem] font-bold sm:text-[3.5rem]">{displayNumber}</div>
			<div className="text-body-md">{label}</div>
		</div>
	)
}

type Props = {
	data?: RankingAllData
	includePercent?: boolean
}

export default function RankTable(props: Props) {
	if (!props?.data) {
		return <div />
	}

	const { overallRank, ageClassSexRank, sex, ageClass, ageGradedPercent } = props.data
	const topPercentile = Math.round((1 - ageGradedPercent) * 100)
	const adjustedPercentile = topPercentile < 1 ? '<1' : topPercentile
	const percentile = `Top ${adjustedPercentile}%`

	return (
		<div className="flex flex-1 flex-col gap-x-10">
			{props.includePercent && <Rank label="Efforts All Time" number={percentile} />}
			<div className="flex flex-1 justify-center gap-x-10">
				<Link to={`/leaderboard?age=${ageClass}&sex=${sex}`}>
					<Rank label="Division" number={ageClassSexRank} />
				</Link>
				<Link to="/leaderboard">
					<Rank label="Overall" number={overallRank} />
				</Link>
			</div>
		</div>
	)
}
